import { createElement } from 'react';
const computedInput = (k, v) => (v ? (Number(v) ? { [k]: `${v}px` } : { [k]: v }) : {});
const getToken = () => {
    const gainCookieByKey = (param) => {
        const cookieStr = document.cookie;
        if (cookieStr) {
            const cookieArr = cookieStr.split(';');
            const cArrLen = cookieArr.length;
            for (let i = 0; i < cArrLen; i += 1) {
                const kv = cookieArr[i].split('=');
                kv[0] = kv[0].replace(/(^\s*)|(\s*$)/g, '');
                if (kv[0] === param) {
                    kv[1] = kv[1].replace(/(^\s*)|(\s*$)/g, '');
                    return kv[1];
                }
            }
        }
        return '';
    };
    const tokenKey = '_security_token_inc';
    return gainCookieByKey(tokenKey);
};
const IframeContainer = function Container({ style = {}, width, height, joinParams, isSoubi, params, src, }) {
    const defaultStyle = {
        width: '100%',
        height: '100%',
    };
    const inputStyle = Object.assign({}, computedInput('width', width), computedInput('height', height));
    const finalStyle = Object.assign(defaultStyle, style, inputStyle);
    let finalSrc = src;
    if (src && joinParams && isSoubi) {
        const [before, after] = src.split('#');
        const center = `&token=${getToken()}`;
        finalSrc = `${before}${center}${after}`;
    }
    if (src && joinParams && params) {
        const stringParam = params.map(({ key, value }) => `${key}=${value}`).join('&');
        const addParamSign = finalSrc.includes('?') ? '&' : '?';
        finalSrc = `${finalSrc}${addParamSign}${stringParam}`;
    }
    return createElement("iframe", { src: finalSrc, style: finalStyle });
};
IframeContainer.displayName = 'IframeContainer';
export default IframeContainer;
